export class GridSummary {
    
    gesamtAuftragswert: number = 0;
    istStandAuftrag: number = 0;
    prognose: number = 0;
    basiskostenBudget: number = 0;
    kostenvarianz: number = 0;
    kostenvarianzWert: number = 0;
    baukosten: number = 0;
    baukostenLetztgueltig: number = 0;
    differenzLetztgueltig: number = 0;
    differenzLetztgueltigProzent: number = 0;
    jahrVergangenheitProzent: number = 0;
    jahr0Prozent: number = 0;
    jahr1Prozent: number = 0;
    jahr2Prozent: number = 0;
    jahr3Prozent: number = 0;
    jahr4Prozent: number = 0;
    jahr5Prozent: number = 0;
    jahrZukunftProzent: number = 0;
    jahrSummeProzent: number = 0;
    restProzent: number = 0;
    jahrVergangenheit: number = 0;
    jahr0: number = 0;
    jahr1: number = 0;
    jahr2: number = 0;
    jahr3: number = 0;
    jahr4: number = 0;
    jahr5: number = 0;
    jahrZukunft: number = 0;
    jahrSumme: number = 0;
    rest: number = 0;

    constructor(){}
}